var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isVisible)?_c('cv-toast-notification',{attrs:{"kind":"info","hide-close-button":false,"title":_vm.title,"sub-title":_vm.subtitle},on:{"close":function($event){return _vm.$emit('notification:closed', true)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }